const _ = require('lodash');

const isSimpleExpression = expression => _.isString(expression);

const isCompoundExpression = expression => {
  if (!expression) return false;
  return expression.and || expression.or;
};

const getConnectiveOperator = expression => {
  if (!expression) return null;
  if (expression.or) return 'or';
  if (expression.and) return 'and';
  return null;
};

const compile = (expression, getTarget, getOperation, getResource, resources) => {
  const expressionToFilter = currentExpression => {
    const [target, operation, args] = currentExpression.split(' ');
    const filterTarget = getTarget(target);
    return {
      target: filterTarget,
      operation: getOperation(operation),
      args: getResource(args, filterTarget, resources)
    };
  };

  const convertExpression = currentExpression => {
    if (isSimpleExpression(currentExpression)) return expressionToFilter(currentExpression);

    if (isCompoundExpression(currentExpression)) {
      const operator = getConnectiveOperator(currentExpression) || 'and';
      return {
        operator,
        filters: currentExpression[operator].map(convertExpression)
      };
    }

    if (_.isArray(currentExpression)) return currentExpression.map(convertExpression);
    if (_.isObject(currentExpression)) return _.mapValues(currentExpression, convertExpression);
    return currentExpression;
  };

  if (!expression) return expression; // Convert flat expression to an AND with a single expression

  if (!getConnectiveOperator(expression)) {
    return convertExpression({
      and: [expression]
    });
  }

  return convertExpression(expression);
};
/**
 * queryToFilterSetFactory
 * @param getTarget
 * @param getOperation
 * @param getResource
 * @returns {function(query): (filterSet)}
 */


const queryToFilterSetFactory = ({
  getTarget,
  getOperation,
  getResource
}) => query => {
  if (!query) return query;
  const {
    resources,
    expression
  } = query;
  return compile(expression, getTarget, getOperation, getResource, resources);
};

module.exports = queryToFilterSetFactory;